import {useMutation} from "@tanstack/react-query";
import {toggleGameFeedLikeService} from "../../services/games/gameFeed/gameFeed.service";

const useToggleGameFeedLike = () => {
  const {mutate, isPending} = useMutation({
    mutationFn: toggleGameFeedLikeService,
  });

  return {toggleLike: mutate, isToggling: isPending};
};

export default useToggleGameFeedLike;
